import { emailValidation } from '@percihealth/core-js';
import { InferType, object } from 'yup';

export const ReferrerHealixSchema = object().shape({
  email: emailValidation.required('Your email is required'),
});

export type ReferrerHealix = InferType<typeof ReferrerHealixSchema>;
